import React, { useState, useEffect, useMemo } from "react";
import { api } from "../../../api";
import { useQuery } from "react-query";
import Card from "../dashboard/components/Card";
import { exams as examsApi } from "../../../api/exams";
import { useTranslation } from 'react-i18next';
import Loader from "../../../components/loader/Loader";
import Pagination from "../../../components/Pagination/Pagination";
import Input from "../../../components/input/Input";
import EmptyData from "../../../components/EmptyData";
import SurveyCard from "../dashboard/components/SurveyCard";
import LanguageSwitcher from "../../../components/LanguageSwitcher";

const SelfReview = ({ width }) => {
  const storedBranding = useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem("branding"));
    } catch (error) {
      return null;
    }
  }, []);
  const appearance = storedBranding?.data?.appearance;

  const [showRedirect, hideRedirect] = useState(false);
  const user = JSON.parse(sessionStorage.getItem('user'))
  // Culture audit hides the sidebar (see CandidateRoutes.jsx), which is the
  // only place the client logo normally appears — show it here instead.
  const isCultureAudit = user?.sub_type === "culture";
  // Branded culture audits should only show the client's palette — swap the
  // default green "completed" styling for neutral grey/black.
  const useNeutralStatus = isCultureAudit && !!appearance?.theme_colour;
  const { t, i18n: i18nNext, } = useTranslation();
  // Culture audit participants shouldn't see "Self Evaluation" wording.
  const label = (key) => t(isCultureAudit ? key.replace("self-evaluations", "culture-surveys") : key);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(30);
  const [search, setSearch] = useState('')

  const { isLoading: surveysLoading, data: surveys, refetch } = useQuery(
    ["user exams", currentPage, perPage, search],
    async () => {
      const data = await examsApi.getSurveys({
        type: null, id: user?.user?.user_id, currentPage, perPage, search, client_id: user?.client_id
      });
      return data;
    },
    {
      select: (data) => data,
      refetchOnWindowFocus: false,
    }
  );

  const { data: summaryData, isLoading: summaryLoading } = useQuery(
    ["Self survey Summary Data"],
    async () => {
      const data = await api.getDashboardSummary(user?.user?.user_id, user?.client_id);
      return data;
    },
    {
      select: (response) => response?.data,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    }
  );

  useEffect(() => {
    hideRedirect(true);
  }, []);

  return (
    <React.Fragment>
      {(
        <>
          {/*( showRedirect && mockAssessment?.length) ? 
               <Redirect handleRedirect={hideRedirect} /> : null 
           */}
          {isCultureAudit && appearance?.desktop_logo && (
            <div className="mb-4">
              <img src={appearance.desktop_logo} alt="logo" className="h-12 object-contain" />
            </div>
          )}
          <div className="flex items-center justify-between gap-3">
            <h1
              className="text-white rounded-lg shadow bg-primary py-4 px-3 pt-4 flex-1"
              style={{ fontSize: "20px", marginTop: "0px", backgroundColor: appearance?.theme_colour }}
            >
              {label("self-evaluations")}
            </h1>
            <LanguageSwitcher />
          </div>
          <p className="text-gray-600 text-lg mt-2">
            {label("self-evaluations-subtitle")}
          </p>
          <div
            className="mt-1 gap-4"
            style={{
              display: "flex",
              width: "100%",
              // gridTemplateColumns: width > 768 ? "4fr 1.5fr" : "1fr",
              //  border: "1px solid #ccc",
            }}
          >
            <div className="w-full md:pt-0">
              {/*WELCOME SECTION*/}
              <div className="mb-12 mt-5 justify-between grid gap-5 grid-cols-1 md:grid-cols-3">
                <Card
                  title={t('total-surveys')}
                  text={summaryData?.self_reviews?.selfReviewAssigned || 0}
                  color="text-gray-900"
                  bgColor={'bg-white'}
                  isLoading={summaryLoading}
                  description={label('self-evaluations-assigned')}
                  width="w-full"
                />
                <Card
                  title={t('pending')}
                  text={summaryData?.self_reviews?.selfReviewPending || 0}
                  bgColor={'bg-orange-50'}
                  color="text-orange-500"
                  isLoading={summaryLoading}
                  description={label('self-evaluations-pending')}
                  width="w-full"
                />
                <Card
                  title={t('completed')}
                  bgColor={useNeutralStatus ? 'bg-gray-50' : 'bg-green-50'}
                  text={summaryData?.self_reviews?.selfReviewCompleted || 0}
                  isLoading={summaryLoading}
                  color={useNeutralStatus ? "text-gray-900" : "text-[#87AA4B]"}
                  description={label('self-evaluations-completed')}
                  width="w-full"
                />
              </div>
              <section>
                <div className="md:flex items-center justify-between mb-3">
                  <h5 className="max-[500px]:mb-3 text-xl font-semibold" style={{ color: appearance?.theme_colour }}>
                    {label("my-self-evaluations")}
                  </h5>
                  <div className="w-full md:w-[300px] text-slate-950">
                    <Input
                      type='search'
                      placeholder={t('search-surveys')}
                      onChange={event => setSearch(event.target.value)}
                    />
                  </div>
                </div>
                {
                  surveysLoading ? (
                    <Loader />
                  ) :
                    !surveys?.data?.length > 0 ? (
                      <EmptyData text={t('no-surveys-found')} />
                    ) :
                      <div className="mb-12 grid gap-5 grid-cols-1 md:grid-cols-3">
                        {
                          surveys?.data?.map((survey, index) => (
                            <SurveyCard refetch={refetch} survey={survey} key={survey?.id} />
                          ))
                        }
                      </div>

                }
              </section>
              <Pagination
                data={surveys?.meta}
                perPage={perPage}
                pageNo={currentPage}
                setPageNo={setCurrentPage}
                setPerPage={setPerPage}
              />
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default SelfReview;

